<template>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :disablePast="true"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="dates"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="addDate"
        @click-event="onClick"
        @drop-on-date="onDragged">

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">

            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                  <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                  <span>{{ label.text }}</span>
                </div>
                <div class="flex items-center mr-4 mb-2">
                  <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                  <span>None</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

  </div>
</template>

<script>
  import moment from 'moment';
  import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
  require("vue-simple-calendar/static/css/default.css")
  import { v4 as uuidv4 } from 'uuid';
  import Datepicker from 'vuejs-datepicker'
  import { en, he } from "vuejs-datepicker/src/locale"

  export default {
    components: {
      CalendarView,
      CalendarViewHeader,
      Datepicker
    },
    props : ['value'],
    data() {
      return {
        showDate: new Date(),
        disabledFrom: false,
        id: 0,
        title: '',
        startDate: '',
        endDate: '',
        labelLocal: 'none',

        langHe: he,
        langEn: en,

        url: '',
        calendarView: 'month',

        activePromptAddEvent: false,
        activePromptEditEvent: false,

        calendarViewTypes: [
          {
            label: "Month",
            val: "month"
          },
          {
            label: "Week",
            val: "week"
          }
        ],

        events : [],
        eventLabels: [],

        dates : [],
      }
    },
    computed: {
      validForm() {
        return this.title !== '' && this.startDate !== '' && this.endDate !== '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
      },
      calendarLabels() {
        return this.eventLabels
      },
      windowWidth() {
        return this.$store.state.windowWidth
      }
    },
    methods: {
      addDate(date){
        let _date = moment(date).format('YYYY-MM-DD');
        if(!this.dates.find(item => item.date === _date)){
          const obj = {id: uuidv4(), title: _date, startDate: date, endDate: date, classes : 'event-success', date:_date }
          this.dates.push(obj);
          this.emitValue();
        }
      },
      onDragged(event, date) {
        let _date = moment(date).format('YYYY-MM-DD');
        let dates = _.cloneDeep(this.dates);
        for(let i=0; i<dates.length; i++){
          if(dates[i].id === event.id){
            dates[i].title = _date;
            dates[i].startDate = _date;
            dates[i].endDate = _date;
            dates[i].date = _date;
          }
        }
        this.dates = dates;
        this.emitValue();
      },
      onClick(event){
        //Ask to remove
        const e = this.dates.find(item => item.id === event.id);
        this.$vs.dialog({
          type:'confirm',
          color: 'danger',
          title: `Confirm`,
          text: `Are you sure yo want to remove ${e.date}?`,
          accept:()=>{
            this.dates.splice(this.dates.findIndex(item=>item.id === event.id),1);
            this.emitValue();
          }
        })
      },
      emitValue(){
        this.$emit('input', this.dates.map(item => item.date));
      },

      updateMonth(val) {
        this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
      },

    },
    created(){
      this.dates = this.value.map(item => {
        let _date = moment(item,'YYYY-MM-DD');
        return  {id: uuidv4(), title: item, startDate: _date.toDate(), endDate:  _date.toDate(), classes : 'event-success', date: item }
      })
    },
    beforeDestroy() {

    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
